<template>
    <div class="bg-white rounded p-5">
        <h3 class="mb-4" style="color: #1a0054">
            <strong>Crea tus rutas</strong>
        </h3>
        <div
            class="d-lg-flex align-items-center justify-content-between mb-4 gap-2"
        >
            <div class="justify-content-star d-flex">
                <span>Selecciona los usuarios que se asignarán a la ruta:</span>
            </div>
            <div class="justify-content-center d-lg-flex d-md-flex d-sm-grid">
                <search-input-component
                    :search="search"
                    @onSearch="onFilterSearch($event)"
                ></search-input-component>
                <select
                    v-if="empresas.length > 0"
                    class="btn bg-utel-v2-secondary sin-borde text-primary rounded-8 mx-1 my-sm-2 pt-2"
                    id=""
                    @change="getEstudiantes()"
                    v-model="empresaSelected"
                >
                    <option value="" selected>Seleccione una empresa..</option>
                    <option v-for="r of empresas" :key="r.id" :value="r">
                        {{ r.client }}
                    </option>
                </select>
            </div>
        </div>
        <v-data-table
            v-show="!loadingTable"
            :headers="headersTabs"
            :items="users"
            item-key="name"
            :search="search"
            :page="page"
            :items-per-page="itemsPerPage"
            class="elevation-1 table text-center align-middle small"
            loading-text="Cargando..."
            mobile-breakpoint="0"
            :header-props="{
                sortIcon: 'fa-solid fa-sort-amount-desc',
            }"
            hide-default-footer
        >
            <template slot="no-data">
                <div>No hay datos disponibles.</div>
            </template>
            <template v-slot:item="row">
                <tr class="text-center">
                    <td>
                        <input
                            type="checkbox"
                            :value="row.item.id"
                            :checked="selectedUsers.includes(row.item.id)"
                            v-model="selectedUsers"
                        />
                    </td>
                    <td>{{ row.item.firstname }} {{ row.item.lastname }}</td>
                    <td>{{ row.item.email }}</td>
                    <td>{{ row.item.position }}</td>
                </tr>
            </template>
            <template v-slot:footer>
                <div class="text-center pt-2">
                    <v-pagination
                        v-model="page"
                        :length="pageCount"
                        :total-visible="6"
                        next-icon="fas fa-angle-right"
                        prev-icon="fas fa-angle-left"
                    ></v-pagination>
                </div>
            </template>
        </v-data-table>

        <loading-component v-show="loadingTable"></loading-component>

        <div class="col-12 text-end">
            <button
                ref="backButton"
                class="btn bg-utel-v2-secondary sin-borde text-primary rounded-8 mx-1 my-sm-2 pt-2"
                :disabled="isCreating"
                @click="goBack"
            >
                Regresar
            </button>
            <button
                ref="createButton"
                class="btn bg-utel text-white sin-borde rounded-8 px-5"
                :disabled="isCreating"
                @click="createRoute"
            >
                <span
                    v-if="isCreating"
                    class="spinner-border spinner-border-sm me-1"
                ></span>
                {{ isCreating ? "Creando ruta..." : "Crear ruta" }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "CreateCustomRouteInfoUsers",
    props: {
        url_get_students: { type: String, required: true },
        url_get_companies: { type: String, required: true },
        info: { type: Object, required: true },
        empresa_elegida: { type: [String, Object], default: "" },
        url_custom_routes: { type: String, required: true },
    },
    emits: ["setRuta", "changeStep", "recargaTable"],
    data() {
        return {
            search: "",
            headersTabs: [
                { text: "#", value: "id", width: "10px" },
                { text: "Colaboradores", value: "firstname" },
                { text: "Email", value: "email" },
                { text: "Cargo", value: "position" },
            ],
            users: [],
            totalItems: 0,
            page: 1,
            itemsPerPage: 10,
            pageCount: 0,
            empresaSelected: "",
            empresas: [],
            selectedUsers: [],
            loadingTable: true,
            isCreating: false,
            searchTimeout: null,
        };
    },
    async mounted() {
        await this.loadCompanies();
        await this.$nextTick();

        if (
            (this.empresas.length > 0 && this.empresa_elegida) ||
            this.empresas.length === 0
        ) {
            this.empresaSelected = this.empresa_elegida || "";
            await this.loadUsers(true);

            if (this.info.students?.length > 0) {
                this.selectedUsers = this.info.students;
            }
        } else {
            this.loadingTable = false;
        }
    },
    watch: {
        page() {
            this.loadUsers();
        },
        itemsPerPage() {
            this.page = 1;
            this.loadUsers();
        },
        search() {
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                this.page = 1;
                this.loadUsers();
            }, 400);
        },
    },
    methods: {
        async loadCompanies() {
            try {
                const { data } = await axios.get(this.url_get_companies);
                this.empresas = data.companies;
            } catch (error) {
                console.error("Error al cargar empresas:", error);
            }
        },
        async loadUsers(keepSelection = false) {
            this.loadingTable = true;

            let url = this.url_get_students;
            if (this.empresaSelected) {
                url = this.empresaSelected.users;
            } else if (this.empresas.length > 0) {
                this.users = [];
                this.loadingTable = false;
                return;
            }

            const params = new URLSearchParams({
                onlyByClient: true,
                onlyClient: true,
                page: this.page,
                per_page: this.itemsPerPage,
            });

            if (this.search) {
                params.append("search", this.search);
            }

            try {
                const { data } = await axios.get(`${url}?${params}`);
                this.users = data.data;
                this.totalItems = data.total;
                this.page = data.current_page;
                this.pageCount = data.last_page;

                if (!keepSelection) {
                    this.selectedUsers = [];
                }
            } catch (error) {
                console.error("Error al cargar usuarios:", error);
            } finally {
                this.loadingTable = false;
            }
        },
        onFilterSearch(searchText) {
            this.search = searchText;
        },
        changeStep(step) {
            this.info.students = this.selectedUsers;
            this.$emit("setRuta", this.info);
            this.$emit("changeStep", step);
        },
        async createRoute() {
            if (this.selectedUsers.length === 0) {
                await this.$swal({
                    icon: "warning",
                    title: "Atención",
                    text: "Debe seleccionar al menos un colaborador",
                    confirmButtonText: "Aceptar",
                });
                return;
            }

            let url = this.url_custom_routes;
            if (this.empresaSelected) {
                url = this.empresaSelected.routes;
            }

            this.info.students = this.selectedUsers;
            const nuevaRuta = {
                name: this.info.name,
                description: this.info.description,
                validity_time: this.info.validity_time,
                type_period: this.info.type_period,
                cursos: this.info.courses,
                students: this.selectedUsers,
            };

            this.isCreating = true;

            try {
                await axios.post(url, {
                    newClient: nuevaRuta,
                    parent_id: this.info.parentId,
                });

                localStorage.removeItem("cursoDefecto");

                this.$emit("recargaTable", true);
                this.changeStep(4);
            } catch (error) {
                console.error("Error al crear ruta:", error);

                await this.$swal({
                    icon: "error",
                    title: "Error",
                    text:
                        error.response?.data?.message ||
                        "No se pudo crear la ruta",
                    confirmButtonText: "Aceptar",
                });
            } finally {
                this.isCreating = false;
            }
        },
        goBack() {
            this.$emit("setRuta", this.info);
            this.$emit("changeStep", 2);
        },
        getEstudiantes(load = null) {
            this.loadUsers(load === "load");
        },
    },
};
</script>
